import React from "react";
import { AHText, Box } from "arkh";
import { graphql, useFragment } from "react-relay";

import { WidgetTeamScheduleContentSectionHeader_teamSchedule$key } from "./__generated__/WidgetTeamScheduleContentSectionHeader_teamSchedule.graphql";
import Color from "color";
import { WidgetTeamScheduleContentStatus } from "./WidgetTeamScheduleContentStatus";

export const WidgetTeamScheduleContentSectionHeader = (props: {
  teamSchedule: WidgetTeamScheduleContentSectionHeader_teamSchedule$key;
  tint: string;
}) => {
  const teamSchedule = useFragment(
    graphql`
      fragment WidgetTeamScheduleContentSectionHeader_teamSchedule on TeamSchedule {
        id
        freq
        label
        ...WidgetTeamScheduleContentStatus_teamSchedule
      }
    `,
    props.teamSchedule
  );

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: Color(props.tint).lightness(98).toString(),
      }}
      color="surface-primary"
      spaceBottom="xxsmall"
      spaceHorizontal="small"
    >
      <AHText type="subtitle" color="text-secondary">
        {teamSchedule?.label ?? ""}
      </AHText>
      <WidgetTeamScheduleContentStatus teamSchedule={teamSchedule} />
    </Box>
  );
};
